module.exports = __webpack_public_path__ + "static/img/csv.6bfd65e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/file-uploader/csv.svg
// module id = WQq5
// module chunks = 46